/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
import React from "react";

import { Dialog, DialogContent, Paper, TextField, Typography } from "@material-ui/core";
import "cropperjs/dist/cropper.css";
import { Autocomplete } from "@material-ui/lab";
import Draggable from 'react-draggable';

import Button from 'components/Button/button';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-nfce-update-item"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper {...props} />
    </Draggable>
  );
}

function UpdateNfceItemDialog({
  onClose,
  open,
  isNewItem,
  currentItem,
  setCurrentItem,
  addItem,
  removeItem,
  handleUpdateItem,
  unitsMeasurementsOptions
}) {
  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose()
      }}
      className="defaultModal nfceUpdateItemDialog customZIndex"
      PaperComponent={PaperComponent}
    >
      <DialogContent className="modalContent pt8 bgWhite dFlex justifyBetween flexColumn alignCenter">
        <div className="defaultItemLine">
          <span>
            DESCRIÇÃO
          </span>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            name="quantity"
            type="text"
            value={currentItem?.description}
            onChange={(e) => {
              setCurrentItem({
                ...currentItem,
                description: e?.target?.value
              })
            }}
            className="textFieldSmall"
            placeholder="Digite aqui..."
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{ style: { fontFamily: 'Lato' } }}
          />
        </div>

        <div className="defaultItemLine">
          <span>
            CÓDIGO
          </span>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            name="quantity"
            type="number"
            value={currentItem?.code}
            onChange={(e) => {
              setCurrentItem({
                ...currentItem,
                code: e?.target?.value
              })
            }}
            className="textFieldSmall"
            placeholder="Digite aqui..."
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{ style: { fontFamily: 'Lato' } }}
          />
        </div>

        <div className="defaultItemLine">
          <span>
            QTDE
          </span>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            name="quantity"
            type="number"
            value={currentItem?.quantity}
            onChange={(e) => {
              setCurrentItem({
                ...currentItem,
                quantity: e?.target?.value
              })
            }}
            className="textFieldSmall"
            placeholder="Digite aqui..."
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{ style: { fontFamily: 'Lato' } }}
          />
        </div>

        <div className="defaultItemLine">
          <span>
            UNIDADE
          </span>
          
          <Autocomplete
            options={unitsMeasurementsOptions || []}
            getOptionLabel={(option) => option.abbreviation}
            size="small"
            value={unitsMeasurementsOptions?.find((el) => el.abbreviation === currentItem?.unitMeasurement)}
            onChange={(_event, value) => {
              setCurrentItem({
                ...currentItem,
                unitMeasurement: value?.abbreviation || ''
              })
            }}
            className="autocompleteSmall"
            renderInput={(params) => (
              <TextField
                {...params}
                id={params.id}
                type="text"
                name="unitsMeasurementsId"
                variant="outlined"
                required
                placeholder="Selecione..."
                InputLabelProps={{
                  shrink: true
                }}
              />
            )}
            renderOption={(params) => (
              <Typography
                style={{
                  fontSize: '12px',
                  fontFamily: 'Lato'
                }}
              >
                {params.abbreviation}
              </Typography>
            )}
          />
        </div>

        <div className="defaultItemLine">
          <span>
            UN. R$
          </span>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            name="quantity"
            type="number"
            value={currentItem?.unitaryValue}
            onChange={(e) => {
              setCurrentItem({
                ...currentItem,
                unitaryValue: e?.target?.value
              })
            }}
            className="textFieldSmall"
            placeholder="Digite aqui..."
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{ style: { fontFamily: 'Lato' } }}
          />
        </div>

        <div className="editItemActionButtons">
          {!isNewItem ?
            <>
              <Button 
                onClick={() => {
                  removeItem()
                }}
                className="defaultButton errorButton"
                design="outlined"
                label="Excluir"
              />

              <Button 
                onClick={() => {
                  onClose()
                }}
                className="defaultButton backButton"
                design="outlined"
                label="Cancelar"
              />

              <Button 
                onClick={() => {
                  handleUpdateItem()
                }}
                className="defaultButton submitButton"
                disabled={!currentItem?.quantity || !currentItem?.unitaryValue}
                design="outlined"
                label="Salvar"
              />
            </>
          :
            <>
              <Button 
                onClick={() => {
                  onClose()
                }}
                className="defaultButton backButton"
                design="outlined"
                label="Cancelar"
              />

              <Button 
                onClick={() => {
                  addItem()
                }}
                className="defaultButton submitButton"
                disabled={!currentItem?.quantity || !currentItem?.unitaryValue}
                design="outlined"
                label="Adicionar"
              />
            </>
          }
        </div>
      </DialogContent>
    </Dialog>
  );
}
  
export default UpdateNfceItemDialog;